/**
 * 获取url上的参数
 */

const getUrlParams = (url = window.location.href) => {
  const params = {}
  const paramsStr = url.split('?')[1]
  if (paramsStr) {
    const paramsArr = paramsStr.split('&')
    const reg = /(\/?#\/.*)/
    paramsArr.forEach(item => {
      const key = item.split('=')[0]
      let val = item.split('=')[1] || ''
      val = val.toString().replace(reg, '')
      params[key] = val
    })
  }
  if (url.split('?')[2]) {
    const paramsStr2 = url.split('?')[2]
    const paramsArr = paramsStr2.split('&')
    const reg = /(\/?#\/.*)/
    paramsArr.forEach(item => {
      const key = item.split('=')[0]
      let val = item.split('=')[1] || ''
      val = val.toString().replace(reg, '')
      params[key] = val
    })
  }
  return params
}

export default getUrlParams
